/**
 * Track chunk load errors for monitoring and debugging
 * Can be integrated with services like Sentry, LogRocket, etc.
 */
export function trackChunkLoadError(error: Error) {
  const errorData = {
    type: 'chunk_load_error',
    message: error.message,
    stack: error.stack,
    userAgent: navigator.userAgent,
    timestamp: new Date().toISOString(),
    currentUrl: window.location.href,
    referrer: document.referrer,
    online: navigator.onLine,
    connection: (navigator as any).connection?.effectiveType || 'unknown'
  };

  console.error('[CHUNK_ERROR]', errorData);

  // TODO: Send to your monitoring service
  // Example: Sentry.captureException(error, { extra: errorData });
  // Example: LogRocket.captureException(error, { extra: errorData });
  
  // For now, just log to console
  return errorData;
}

/**
 * Track general application errors
 */
export function trackError(error: Error, context?: Record<string, any>) {
  console.error('[APP_ERROR]', {
    message: error.message,
    stack: error.stack,
    context,
    timestamp: new Date().toISOString()
  });

  // TODO: Send to your monitoring service
}
